import { view, store as createStore } from '@risingstack/react-easy-state'
import { debug, storeDebugger } from '../utilities/logger'
import authentication from './authentication'
import location from './location'
import search from './search'
import inquiry from './inquiry'
import inquiries from './inquiries'
import countries from './countries'
import account from './account'
import metadata from './metadata'
import avanceImmediate from './avanceImmediate'

/**
 * [Store]
 */
const stores = {
  location,
  authentication,
  search,
  countries,
  inquiry,
  inquiries,
  account,
  avanceImmediate,
  metadata,
  connectAs
}

storeDebugger('location', location)
storeDebugger('authentication', authentication)
storeDebugger('search', search)
storeDebugger('countries', countries)
storeDebugger('inquiry', inquiry)
storeDebugger('inquiries', inquiries)
storeDebugger('account', account)
storeDebugger('avanceImmediate', avanceImmediate)
storeDebugger('metadata', metadata)

/**
 * [Functions]
 */
async function initialize () {
  debug(`[stores][initialize] Initializing default state`)
  await Promise.all([
    stores.authentication.initialize(),
    stores.search.initialize(),
    stores.inquiry.initialize()
  ])
  debug(`[stores][initialize] Finished initialization`)
}

// TODO(): This fails bad when token is considered valid but
// getConnectedAccount doesn't work
// ex: connect on staging then switch to production
// fixme
async function connect () {
  debug(`[stores][connect] Trying to reconnect user`)
  if (!stores.authentication.isAuthententicated() && stores.authentication.canRefresh()) {
    debug(`[stores][connect] Refreshing token`)
    await stores.authentication.refresh()
  }
  if (stores.authentication.isAuthententicated()) {
    debug(`[stores][connect] Retrieving connected user`)
    await account.getAccount()
  }
}

async function connectAs ({ access_token, token_type, expires_in, email }) {
  await authentication.connectAs({ access_token, token_type, expires_in, email })
  await connect()
}

const initialization = initialize().then(connect).catch(function (error) {
  // Never leave every page hanging on `await initialization` if reconnecting the user
  // fails (refresh() already logs out on its own errors, so this is getAccount()
  // rejecting with a token that still looks valid). The token is kept, but
  // stores.account.connected may stay null: callers must not assume it is set.
  debug(`[stores][initialization] Initialization failed, account not loaded: ${error}`)
})

export {
  stores,
  view,
  createStore,
  initialization
}



// WEBPACK FOOTER //
// ./src/stores/index.js